import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ChevronUp } from "feather-icons-react/build/IconComponents";
import { useDispatch, useSelector } from "react-redux";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { all_routes } from "../../../Router/all_routes";
import { setToogleHeader } from "../../../core/redux/action";
// import axios from "axios";
// import { CheckCircle } from "react-feather";
// import { backendUrl } from "../../../config";
// import DateRangePicker from "../../components/DateRange/DateRangePicker";
import CommonUnicommerce from "../../common/CommonUnicommerce";
// import moment from "moment";

const InventorySync = () => {
  const route = all_routes;
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);
  // const SunshineToken = localStorage.getItem("Token") || null;

  // const [startDate, setStartDate] = useState(null);
  // const [endDate, setEndDate] = useState(null);
  // const [startDateSecond, setStartDateSecond] = useState(null);
  // const [endDateSecond, setEndDateSecond] = useState(null);
  
  // console.log(startDateSecond, endDateSecond, "jobDateRange 1");
  // const [sunShineToken, setSunShineToken] = useState(SunshineToken || "");
  // const [jobCode, setJobCode] = useState("");
  // const [filePath, setFilePath] = useState("");
  // // const [jobStartDate, setJobStartDate] = useState("");
  // // const [jobEndDate, setJobEndDate] = useState("");
  // const [stepStatus, setStepStatus] = useState({
  //   generateToken: SunshineToken ? true : false,
  //   generateTokenLoading: false,
  //   createJob: false,
  //   createJobLoading: false,
  //   jobStatus: false,
  //   jobStatusLoading: false,
  //   exportComplete: false,
  //   exportCompleteLoading: false,
  //   SyncStatus: false,
  //   SyncStatusLoading: false,
  // });

  // const [inventoryData, setInventoryData] = useState([]);

  // console.log(inventoryData, "inventoryData");

  // const generateToken = async () => {
  //   setStepStatus((prev) => ({ ...prev, generateTokenLoading: true }));
  //   try {
  //     const response = await axios.get(
  //       `${backendUrl}/unicommerce/tokengenerate`
  //     );
  //     if (
  //       response.data.ResponseCode === "SUCCESS" &&
  //       response.data.ResponseData.access_token
  //     ) {
  //       setSunShineToken(response.data.ResponseData.access_token);
  //       setStepStatus((prev) => ({
  //         ...prev,
  //         generateToken: true,
  //         generateTokenLoading: false,
  //       }));
  //       localStorage.setItem("Token", response.data.ResponseData.access_token);
  //       console.log(
  //         "Token generated successfully:",
  //         response.data.ResponseData.access_token
  //       );
  //     } else {
  //       console.error("Error in token response:", response.data);
  //     }
  //   } catch (err) {
  //     console.error("Error generating token:", err);
  //   }
  // };

  // // const handelDateRange = (item) => {
  // //   console.log(item, "handelDateRange");
  // //   setJobStartDate("");
  // //   setJobEndDate("");
  // // };

  // const CreateInventoryJobObject = {
  //   exportJobTypeName: "Inventory Snapshot",
  //   exportColums: [
  //     "facility",
  //     "itemTypeName",
  //     "itemtypeSku",
  //     "ean",
  //     "upc",
  //     "isbn",
  //     "color",
  //     "size",
  //     "brand",
  //     "categoryName",
  //     "MRP",
  //     "openSale",
  //     "inventory",
  //     "inventoryBlocked",
  //     "badInventory",
  //     "putawayPending",
  //     "pendingInventoryAssessment",
  //     "pendingStockTransfer",
  //     "openPurchase",
  //     "enabled",
  //     "updated",
  //     "costPrice",
  //   ],
  //   exportFilters: [
  //     {
  //       id: "updatedIn",
  //       dateRange: { start: startDate, //1736188200000, 
  //       end: endDate //1736360999999 
  //       } // { start: jobStartDate, end: jobEndDate }, //
  //     },
  //   ],
  //   frequency: "ONETIME",
  // };

  // const createJob = async () => {
  //   try {
  //     setStepStatus((prev) => ({ ...prev, createJobLoading: true }));
  //     const response = await axios.post(
  //       `${backendUrl}/unicommerce/exportjobcreate`,
  //       CreateInventoryJobObject,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${sunShineToken}`,
  //         },
  //       }
  //     );
  //     if (response.data.ResponseData) {
  //       if (response.data.ResponseData.successful) {
  //         setJobCode(response.data.ResponseData.jobCode);
  //         setStepStatus((prev) => ({
  //           ...prev,
  //           createJob: true,
  //           createJobLoading: false,
  //         }));
  //         console.log("Job created successfully:", response.data);
  //       }
  //     } else {
  //       console.error("Error in job creation response:", response.data);
  //     }
  //   } catch (err) {
  //     console.error("Error creating job:", err);
  //   }
  // };

  // const getJobStatus = async () => {
  //   setStepStatus((prev) => ({ ...prev, jobStatusLoading: true }));
  //   try {
  //     const response = await axios.post(
  //       `${backendUrl}/unicommerce/exportjobstatus`,
  //       { jobCode },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${sunShineToken}`,
  //         },
  //       }
  //     );
  //     if (
  //       response.data.ResponseData.successful &&
  //       response.data.ResponseData.status === "COMPLETE"
  //     ) {
  //       setFilePath(response.data.ResponseData.filePath);
  //       setStepStatus((prev) => ({
  //         ...prev,
  //         jobStatus: true,
  //         jobStatusLoading: false,
  //       }));
  //       console.log("Job completed successfully:", response.data);
  //     } else {
  //       console.error("Error in job status response:", response.data);
  //     }
  //   } catch (err) {
  //     console.error("Error fetching job status:", err);
  //   }
  // };

  // const exportInventory = async () => {
  //   console.log("File available at:", filePath);
  //   setStepStatus((prev) => ({ ...prev, exportCompleteLoading: true }));
  //   // window.open(filePath, "_blank"); // direct download button
  //   try {
  //     const response = await axios.post(
  //       `${backendUrl}/unicommerce/exportunicommercedata`,
  //       {
  //         filePath: filePath,
  //         type: "inventory",
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${sunShineToken}`,
  //         },
  //       }
  //     );
  //     console.log(response, "get export");
  //     if (
  //       response.data.ResponseData &&
  //       response.data.ResponseCode === "SUCCESS"
  //     ) {
  //       setInventoryData(response.data.ResponseData);
  //       setStepStatus((prev) => ({
  //         ...prev,
  //         exportComplete: true,
  //         SyncStatus: true,
  //         exportCompleteLoading: false,
  //       }));
  //       console.log("Job Export completed successfully:", response.data);
  //     } else {
  //       console.error("Error in job Export status response:", response.data);
  //     }
  //   } catch (err) {
  //     console.error("Error fetching job status:", err);
  //   }
  // };
  // const downloadExportCSV = () => {
  //   if (filePath) {
  //     window.open(filePath); // "_blank" for open in new tab,  direct download button
  //   } else {
  //     console.log("File not Found, Please ReCreate a Job");
  //   }
  // };


  // const handleCallbackDate = (start, end) => {
  //   console.log(start, end, "handleCallbackDate");
  //   if (start) {
  //     setStartDate(start); // 2020-07-11T06:39:57.490Z
  //     const startInSecond = Math.floor(new Date(moment(start).format('YYYY-MM-DD')+' 12:00:01 AM').getTime());
  //     setStartDateSecond(startInSecond);
  //   }
  //   if (end) {
  //     setEndDate(end);
  //     const endInSecond = Math.floor(new Date(moment(end).format('YYYY-MM-DD')+' 12:00:01 AM').getTime());
  //     setEndDateSecond(endInSecond);
  //   }
  // };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Inventory Sync</h4>
              <h6>Manage Inventory Sync</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li>
              <div className="page-btn">
                <Link to={route.inventory} className="btn btn-secondary">
                  <ArrowLeft className="me-2" />
                  Back to Inventory
                </Link>
              </div>
            </li>
            <li>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="refresh-tooltip">Collapse</Tooltip>}
              >
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Collapse"
                  id="collapse-header"
                  className={data ? "active" : ""}
                  onClick={() => {
                    dispatch(setToogleHeader(!data));
                  }}
                >
                  <ChevronUp className="feather-chevron-up" />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
        </div>

        <CommonUnicommerce type="inventoryes" />
      </div>
    </div>
  );
};

export default InventorySync;
